import IconBase from "./IconBase";

// Sliders rather than a cog: a twelve-tooth gear turns to mush at 20px, while
// two tracks and a handle stay legible and read as "controls".
const SettingsIcon = (props) => (
    <IconBase {...props}>
        <path d="M3 8.5h3.75" />
        <path d="M11.75 8.5H21" />
        <circle cx="9.25" cy="8.5" r="2.5" />
        <path d="M3 15.5h9.25" />
        <path d="M17.25 15.5H21" />
        <circle cx="14.75" cy="15.5" r="2.5" />
    </IconBase>
);

export default SettingsIcon;
